import React from "react";

const ProgrammingBasics = () => {
  return (
    <div className="text-justify py-4">
      <p className="mb-4">
        Pemrograman adalah keterampilan yang semakin penting di dunia digital saat ini. Baik untuk membuat aplikasi web, perangkat lunak, atau sistem lainnya, pemrograman memberikan kekuatan untuk menciptakan dan mengontrol teknologi.
      </p>
      <h2 className="text-2xl font-bold mb-4">Apa Itu Pemrograman?</h2>
      <p className="mb-4">
        Pemrograman adalah proses menulis kode yang memberi instruksi pada komputer untuk melakukan tugas tertentu. Tugas ini bisa sederhana seperti menampilkan pesan atau kompleks seperti memproses data besar dalam sistem.
      </p>
      <h2 className="text-2xl font-bold mb-4">Bahasa Pemrograman yang Umum Digunakan</h2>
      <p className="mb-4">
        Ada banyak bahasa pemrograman yang bisa dipelajari, beberapa di antaranya adalah Python, JavaScript, Java, C++, dan PHP. Pemilihan bahasa tergantung pada jenis aplikasi yang ingin Anda bangun dan tujuan pemrograman Anda.
      </p>
      <h2 className="text-2xl font-bold mb-4">Langkah Pertama: Memulai dengan Python</h2>
      <p className="mb-4">
        Python adalah bahasa pemrograman yang sangat ramah untuk pemula. Sederhana dan memiliki sintaks yang mudah dipahami, Python adalah pilihan yang sangat baik untuk memulai perjalanan pemrograman Anda.
      </p>
      <h2 className="text-2xl font-bold mb-4">Kesimpulan</h2>
      <p className="mb-4">
        Pemrograman adalah keterampilan yang berharga yang membuka pintu untuk banyak peluang. Dengan memahami dasar-dasar coding, Anda dapat mulai membuat aplikasi dan solusi yang berguna.
      </p>
    </div>
  );
};

export default ProgrammingBasics;
